<div class="search-results-container">
  <div class="search-results-wrapper" *ngIf="!!newSearchViewModel?.totalCount">
    <cdk-virtual-scroll-viewport
      class="cdk-scroll"
      orientation="vertical"
      appCustomVs
      [itemHeights]="itemHeights"
      [items]="newSearchViewModel?.products"
      [measureViewportSize]="false"
      (scrolledIndexChange)="onScrolledIndexChange($event)"
    >
      <app-selectable-search-result
        *cdkVirtualFor="
          let product of newSearchViewModel?.products;
          let i = index;
          trackBy: trackProductByIndex
        "
        [class.selectable]="itemsSelectable"
        [mode]="mode"
        [pwrRatingStarsMap]="pwrRatingStarsMap"
        [product]="product"
        [isHideQuantity]="false"
        [isTouchExperience]="isTouchExperience"
        [pageType]="SearchPageType.Search"
        [totalNumberOfRecords]="newSearchViewModel?.totalCount"
        [selectable]="itemsSelectable"
        [index]="i"
        (selectionChange)="updateSelection(product)"
        [replacementProduct]="replacementBaseProduct"
        (cardClicked)="onResultClicked(i)"
      ></app-selectable-search-result>
    </cdk-virtual-scroll-viewport>
  </div>
</div>
